import { PropsWithChildren } from 'react';
import { ClassNames } from '@emotion/react';
import { useAppTranslation } from '@hooks';
import { Drawer, Icon, Text, colors } from 'common-components';

type FiltersDrawerPropsType = PropsWithChildren<{
  open: boolean
  onClose: () => void
}>;

const FiltersDrawer = ({ open, onClose, children }: FiltersDrawerPropsType) => {
  const { translate } = useAppTranslation();

  return (
    <ClassNames>
      {({ css }) => (
        <Drawer
          open={open}
          onClose={onClose}
          size={400}
          closable={{
            placement: 'end',
            closeIcon: <Icon icon="XClose" size={20} color={colors.gray500} />,
          }}
          title={
            <div
              className={css`
                display: flex;
                flex-direction: column;
                gap: 4px;
              `}
            >
              <Text color={colors.gray900} style={{ fontSize: 20, lineHeight: '30px', fontWeight: 500 }}>
                {translate('common.filter')}
              </Text>
              <Text color={colors.gray600}>{translate('common.apply')}</Text>
            </div>
          }
          styles={{
            header: { padding: '24px 24px 0', borderBottom: 'none', alignItems: 'flex-start' },
            body: { padding: 0, display: 'flex', flexDirection: 'column' },
          }}
          rootClassName={css`
            .ant-drawer-body > form {
              flex: 1;
              display: flex;
              flex-direction: column;
              padding: 24px 24px 0;
            }
            .ant-form-item-label > label {
              color: ${colors.gray700};
              font-weight: 500;
            }
          `}
        >
          {children}
        </Drawer>
      )}
    </ClassNames>
  );
};

export const FiltersDrawerFooter = ({ children }: PropsWithChildren) => (
  <ClassNames>
    {({ css }) => (
      <div
        className={css`
          position: sticky;
          bottom: 0;
          display: flex;
          justify-content: flex-end;
          gap: 12px;
          margin: auto -24px 0;
          padding: 16px 24px;
          border-top: 1px solid ${colors.gray200};
          background: ${colors.white};
        `}
      >
        {children}
      </div>
    )}
  </ClassNames>
);

export default FiltersDrawer;
